import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { QuoteTemplateRequest, QuoteTemplateResponse } from '../models/quote-template.model';

@Injectable({
  providedIn: 'root'
})
export class QuoteTemplateApiService {
  private readonly apiUrl = `${environment.apiUrl}api`;

  constructor(private http: HttpClient) { }

  // GET /api/quote-templates?businessId=1 - List all active templates (requires Manager+)
  getAllTemplates(businessId: number): Observable<QuoteTemplateResponse[]> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<QuoteTemplateResponse[]>(`${this.apiUrl}/quote-templates`, { params });
  }

  // GET /api/quote-templates/{id}?businessId=1 - Get template by ID
  getTemplateById(id: number, businessId: number): Observable<QuoteTemplateResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<QuoteTemplateResponse>(`${this.apiUrl}/quote-templates/${id}`, { params });
  }

  // POST /api/quote-templates?businessId=1 - Create template (requires Manager+)
  createTemplate(businessId: number, template: QuoteTemplateRequest): Observable<QuoteTemplateResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.post<QuoteTemplateResponse>(`${this.apiUrl}/quote-templates`, template, { params });
  }

  // PUT /api/quote-templates/{id}?businessId=1 - Update template (requires Manager+)
  updateTemplate(id: number, businessId: number, template: QuoteTemplateRequest): Observable<QuoteTemplateResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.put<QuoteTemplateResponse>(`${this.apiUrl}/quote-templates/${id}`, template, { params });
  }

  // DELETE /api/quote-templates/{id}?businessId=1 - Delete template (requires Admin+)
  deleteTemplate(id: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(`${this.apiUrl}/quote-templates/${id}`, { params });
  }

  // PUT /api/quote-templates/{id}/set-default?businessId=1 - Set as default template (requires Manager+)
  setDefaultTemplate(id: number, businessId: number): Observable<QuoteTemplateResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.put<QuoteTemplateResponse>(`${this.apiUrl}/quote-templates/${id}/set-default`, null, { params });
  }

  // POST /api/quote-templates/{id}/duplicate?businessId=1 - Duplicate template "{name} (copia)" (requires Manager+)
  duplicateTemplate(id: number, businessId: number): Observable<QuoteTemplateResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.post<QuoteTemplateResponse>(`${this.apiUrl}/quote-templates/${id}/duplicate`, null, { params });
  }

  // GET /api/quote-templates/{id}/preview?businessId=1 - Sample PDF with branding applied (requires Manager+)
  previewTemplate(id: number, businessId: number): Observable<Blob> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get(`${this.apiUrl}/quote-templates/${id}/preview`, { params, responseType: 'blob' });
  }
}
